import isEmpty from 'lodash/isEmpty'
import React from 'react'

import { generateUrlFromNode } from '@/utils/url'

import Button from '../button/button'
import * as styles from './tags.module.scss'

type Props = {
  readonly tags: readonly (Queries.TagReferenceFragment | null)[] | null
  readonly topic?: Queries.TopicReferenceFragment | null
}

const Tags: React.FC<Props> = ({ tags, topic }) => {
  if (isEmpty(tags) || tags == null) return <></>
  const urlTopic = topic ? generateUrlFromNode(topic) : ''
  return (
    <div className={styles.tags}>
      <h3 className={styles.label}>Tags</h3>
      <div className={styles.listTags}>
        {topic && (
          <Button to={urlTopic} title={topic?.externalName} color="primary" />
        )}
        {tags.map((tag) => {
          if (tag == null) return null
          const { id, externalName } = tag
          const url = generateUrlFromNode(tag)
          return (
            <Button key={id} to={url} title={externalName} color="secondary" />
          )
        })}
      </div>
    </div>
  )
}

export default Tags
